import React from 'react'
import { Activity, ActivityStatus } from '../../api/schemas/schema'
import { tokens } from '@fluentui/react-components'
import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)

type ActivityStatusBadgeProps = {
   item: Activity
}
export const ActivityStatusBadge = ({ item }: ActivityStatusBadgeProps) => {
   const todaysDate = dayjs().startOf('day')
   const startDate = dayjs.utc(item.startDate).local().startOf('day')
   const endDate = item.endDate ? dayjs.utc(item.endDate).local().startOf('day') : null

   const getBgColor = () => {
      // A completed activity is not overdue, however long ago its end date was - the status wins.
      if (item.status === ActivityStatus.Completed) {
         return '#616161'
      }
      if (startDate.isAfter(todaysDate)) {
         return '#566577'
      } else if (endDate && startDate.isSameOrBefore(todaysDate) && endDate.isSameOrAfter(todaysDate)) {
         return '#13A10E'
      } else if (startDate.isSameOrBefore(todaysDate) && item.endDate === null) {
         return '#FFB900'
      } else if (startDate.isSameOrBefore(todaysDate) && endDate !== null && endDate.isBefore(todaysDate)) {
         return '#D13438'
      }
   }
   return <div style={{ backgroundColor: getBgColor(), width: '4px', minHeight: '30px', borderRadius: tokens.borderRadiusXLarge }}></div>
}
